module.exports = __webpack_public_path__ + "static/media/logo-dark@2x.51ac1b72.png";